export enum InboxConversationStatus {
    NOT_SOLVED = 1,
    SOLVED = 2
}